'use client'

import { forwardRef, useImperativeHandle, useState } from "react"
import styles from './ua.module.scss'
import Icon from "../icon/Icon"

const Accordian = forwardRef((props,ref) => {

  const data = props.data
  const [expandedIndex,setExpandedIndex] = useState(-1)

  const expand = (index) => {
    if (index == expandedIndex) setExpandedIndex(-1)
    else setExpandedIndex(index)
  }

  return <div className={styles.accordian}>
    { data.map((item,index) => (
      <div key={index} className={styles.section}>
        <a className={styles.header} onClick={e => expand(index)}>
          <div className={styles.header_title}>{ item.title }</div>
          <div className={ styles.header_icon + ' ' + (index == expandedIndex ? styles.header_active : '')}>
            <Icon {...props} name="chevron-down"></Icon>
          </div>
        </a>
        <div className={styles.content + ' ' + (index == expandedIndex ? styles.content_active : '')}>
          { item.partial }
        </div>
      </div>
    ))}
  </div>

})

Accordian.displayName = "Accordian"
export default Accordian